export default __webpack_public_path__ + "static/char-s-08-en-ae7c5fa9541c1ba734a9d58a100e3e6b.png";